

export enum UserManagementTabMode {
	CUSTOMER_USERS_ONLY = 'CUSTOMER_USERS_ONLY',
	ADMIN_ORG_USERS_ONLY = 'ADMIN_ORG_USERS_ONLY',
	ALL_USERS = 'ALL_USERS'
}


